<template>
  <div class="row">
    <div class="col-md-8 pt-0 pb-0">
      <label>Descrição</label>
      <input
        type="text"
        v-model="description"
        class="form-control form-control-sm"
      />
    </div>
    <div class="col-md-4 pt-0 pb-0">
      <label>Valor</label>
      <input
        type="text"
        @input="handleInputValue($event.target.value)"
        v-model="value"
        class="form-control form-control-sm c-danger"
      />
    </div>
    <div class="col-md-6 pt-0 pb-0">
      <label>Categoria</label>
      <treeselect
        :options="finance_configuration_category"
        placeholder="SELECIONE..."
        v-model="finance_configuration_category_id"
        noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
      />
    </div>
    <div class="col-md-6 pt-0 pb-0">
      <label>Centro de custo/lucro</label>
      <select
        v-model="finance_configuration_profit_cost_center_id"
        class="form-control form-control-sm"
      >
        <option value="">SELECIONE...</option>
        <option
          v-for="profit_cost_center in finance_configuration_profit_cost_center"
          :key="profit_cost_center.id"
          :value="profit_cost_center.id"
        >
          {{ profit_cost_center.description }}
        </option>
      </select>
    </div>
    <div class="col-md-6 pt-0 pb-0">
      <label>Fornecedor</label>
      <select v-model="provider_id" class="form-control form-control-sm">
        <option value="">SELECIONE...</option>
        <option
          v-for="provider in providers"
          :key="provider.id"
          :value="provider.id"
        >
          {{ provider.company_name }}
        </option>
      </select>
    </div>
    <div class="col-md-6 pt-0 pb-0">
      <label>Forma de pagamento</label>
      <select
        v-model="finance_configuration_payment_methods_id"
        class="form-control form-control-sm"
      >
        <option value="">SELECIONE...</option>
        <option
          v-for="payment_method in finance_configuration_payment_methods"
          :key="payment_method.id"
          :value="payment_method.id"
        >
          {{ payment_method.description }}
        </option>
      </select>
    </div>
    <div class="col-md-6 pt-0 pb-0">
      <label>Tipo de custo</label>
      <select v-model="cost_type" class="form-control form-control-sm">
        <option value="">SELECIONE...</option>
        <option
          v-for="type in cost_types"
          :key="type.value"
          :value="type.value"
        >
          {{ type.description }}
        </option>
      </select>
    </div>
    <div class="col-md-6 pt-0 pb-0">
      <label>Apropriação de custo</label>
      <select v-model="cost_appropriation" class="form-control form-control-sm">
        <option value="">SELECIONE...</option>
        <option
          v-for="appropriation in cost_appropriations"
          :key="appropriation.value"
          :value="appropriation.value"
        >
          {{ appropriation.description }}
        </option>
      </select>
    </div>
    <div class="col-md-12 pt-0 pb-0">
      <vs-select
        label="Tags"
        class="
          col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
          pt-0
          pb-0
          pl-0
          pr-0
        "
        placeholder="SELECIONE..."
        multiple
        autocomplete
        v-model="finance_configuration_tag_ids"
      >
        <vs-select-item
          v-for="tag in finance_configuration_tag"
          :key="tag.id"
          :text="tag.description"
          :value="tag.id"
        />
      </vs-select>
    </div>
    <div class="col-md-12 pb-0">
      <ErrorsMessages :errors="errors" />
    </div>
    <div class="col-md-12 text-right pb-0">
      <v-btn class="btn-cancel mr-2" @click="$emit('cancel')">CANCELAR </v-btn>
      <v-btn @click="add" class="btn-edit"
        ><i class="fas fa-check mr-2"></i>ADICIONAR
      </v-btn>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../../../Components/ErrorsMessages";

import Treeselect from "@riophae/vue-treeselect";

import {
  formatValueNegativeOnKeyUp,
  numbersOnly,
} from "../../../../../../lib/format";

export default {
  name: "AddDebt",
  components: {
    ErrorsMessages,
    Treeselect,
  },
  props: {
    providers: Array,
    finance_client: Array,
    finance_configuration_account: Array,
    finance_configuration_document_types: Array,
    finance_configuration_payment_methods: Array,
    finance_configuration_category: Array,
    finance_configuration_profit_cost_center: Array,
    finance_configuration_tag: Array,
    cost_types: Array,
    cost_appropriations: Array,
  },
  data() {
    return {
      spent_or_gain: "DEBITO",
      description: "",
      value: "",
      finance_configuration_category_id: "",
      finance_configuration_profit_cost_center_id: "",
      provider_id: "",
      finance_configuration_payment_methods_id: "",
      finance_configuration_tag_ids: [],
      cost_type: "",
      cost_appropriation: "",
      errors: [],
    };
  },
  methods: {
    handleInputValue(value) {
      this.value = formatValueNegativeOnKeyUp(value);
    },
    add() {
      let {
        spent_or_gain,
        description,
        value,
        finance_configuration_category_id,
        finance_configuration_profit_cost_center_id,
        provider_id,
        finance_configuration_payment_methods_id,
        finance_configuration_tag_ids,
        cost_type,
        cost_appropriation,
      } = this;

      if (!String(description).trim()) {
        this.errors = [{ message: "Informe a descrição" }];
        return;
      }

      if (!String(value).trim()) {
        this.errors = [{ message: "Informe o valor" }];
        return;
      }

      if (parseFloat(numbersOnly(value)) <= 0) {
        this.errors = [{ message: "Informe o valor acima de 0" }];
        return;
      }

      if (!finance_configuration_category_id) {
        this.errors = [{ message: "Informe a categoria" }];
        return;
      }

      let item = {
        spent_or_gain,
        description,
        value,
        finance_configuration_category_id,
        finance_configuration_profit_cost_center_id,
        provider_id,
        finance_configuration_payment_methods_id,
        finance_configuration_tag_ids,
        cost_type,
        cost_appropriation,
      };

      this.errors = [];

      this.$emit("success", item);
    },
  },
};
</script>
